import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BASE_CONSTANTS } from "@tci/common";

import { NgAuthGuardService } from "../ng-shared/ng-services/ng-auth-guard.service";
import { NgEmptyComponent } from "./ng-empty.component";

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: "register",
                canActivate: [
                    NgAuthGuardService
                ],
                component: NgEmptyComponent
            },
            {
                path: BASE_CONSTANTS.PAGE_NOT_FOUND,
                canActivate: [
                    NgAuthGuardService
                ],
                component: NgEmptyComponent
            },
            {
                path: "**",
                canActivate: [
                    NgAuthGuardService
                ],
                redirectTo: BASE_CONSTANTS.PAGE_NOT_FOUND
            }
        ])
    ],
    exports: [
        RouterModule
    ]
})
export class NgEmptyRoutingModule {
}
